import type { ReactNode } from 'react';

interface MetricCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: ReactNode;
  trend?: {
    value: number;
    positive: boolean;
  };
  variant?: 'default' | 'success' | 'warning' | 'danger';
}

export function MetricCard({
  title,
  value,
  subtitle,
  icon,
  trend,
  variant = 'default',
}: MetricCardProps): ReactNode {
  const valueColorClass = {
    default: 'text-gray-900',
    success: 'text-ds-success',
    warning: 'text-ds-warning',
    danger: 'text-ds-danger',
  }[variant];

  return (
    <div className="card">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">
            {title}
          </p>
          <p className={`mt-2 text-2xl font-semibold ${valueColorClass}`}>
            {value}
          </p>
          {subtitle && (
            <p className="mt-1 text-sm text-gray-400">{subtitle}</p>
          )}
          {trend && (
            <div className="mt-2 flex items-center">
              <span
                className={`text-sm font-medium ${
                  trend.positive ? 'text-ds-success' : 'text-ds-danger'
                }`}
              >
                {trend.positive ? '↑' : '↓'} {Math.abs(trend.value)}%
              </span>
              <span className="ml-2 text-sm text-gray-400">vs last month</span>
            </div>
          )}
        </div>
        {icon && (
          <div className="ml-4 p-2 bg-ds-primary/10 rounded-lg text-ds-primary">
            {icon}
          </div>
        )}
      </div>
    </div>
  );
}
